/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { accountTypePostRequestSchema } from './accountTypePostRequestSchema.ts';
import { accountTypePostResponseSchema } from './accountTypePostResponseSchema.ts';

/**
 * @description 200 response
 */
export const postAccountType200Schema = z.lazy(() => accountTypePostResponseSchema);

/**
 * @description 505 response
 */
export const postAccountType505Schema = z.any();

export const postAccountTypeMutationRequestSchema = z.lazy(() => accountTypePostRequestSchema);

export const postAccountTypeMutationResponseSchema = z.lazy(() => postAccountType200Schema);
